export default "__VITE_ASSET__D_Zl5uZf__"